import { useState, useEffect } from "react";
import episodeStore from "../../stores/episodeStore";
import statusStore from "../../stores/statusStore";

export default function Episodes({selectedShow, selectedSeason}) {
      
    const staStore = statusStore();
    const epStore = episodeStore();

    const [expandedEpisode, setExpandedEpisode] = useState();
    const [episodeStatuses, setEpisodeStatuses] = useState([]);

    const episodes = epStore.episode?.filter((ep) => ep.seriesId === selectedShow?._id) || [];

    const status = statusStore((state) => state.status);

     useEffect(() => {
        epStore.fetchEpisodesBySeries(selectedShow._id);
    }, [selectedShow]);

    useEffect(() => {
        const loadStatuses = async () => {
            const statuses = await staStore.fetchEpisodeStatuses(selectedShow.seriesId);
            setEpisodeStatuses(statuses);
        };
        loadStatuses();
    }, [selectedShow]);

    const toggleEpisodeStatus = async (ep) => {
        let res;
        res = await staStore.updateEpisodeStatus(ep._id);

        if (res === "No existing status") {
            console.log("New status being created");
            // Create new status
            await staStore.createEpisodeStatus(ep.seriesId, ep.seasonNumber, ep.episodeNumber, ep._id, "episode", "Watched");
           
        }
    };

    return (
        <div>
             {!epStore.episode ? (
                    <p className="hint">Loading episodes…</p>
                ) : (
                <div className="seriesEpisodes">
                    {episodes?.filter(ep => Number(ep.seasonNumber) === Number(selectedSeason))
                    .map(ep => {
                        const date = new Date(ep.releaseDate);
                        const formattedDate = date.toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                        });

                        return (
                            <div key={ep._id} className="episodeRow">
                                <img
                                    src={ep.image}
                                    alt={ep.title}
                                    className="episodeImg"
                                />
                                <div className="episodeContent">
                                    <div className="episodeHeader">
                                        <span className="episodeTitle">{ep.episodeNumber}. {ep.title}</span>
                                        {/* <label class="checkbox-container">
                                            <input type="checkbox" id="episodeCheckbox"
                                                className="episodeCheckbox"
                                                checked={status?.some(
                                                (s) =>
                                                    s.seriesId === selectedShow._id &&
                                                    s.userStatus === "Watched" &&
                                                    s.targetType === "episode" &&
                                                    s.season === selectedSeason &&
                                                    s.episode === ep.episodeNumber
                                                )}
                                                onChange={() => toggleEpisodeStatus(ep)}></input>
                                                <span className="checkmark"></span>
                                        </label> */}
                                    </div>
                                    <p
                                        className={`episodeDescription ${
                                            expandedEpisode === ep._id ? "" : "clamp"
                                        }`}
                                        onClick={() =>
                                            setExpandedEpisode(
                                            expandedEpisode === ep._id ? null : ep._id
                                            )
                                        }
                                        >
                                        {ep.description}
                                    </p>
                                    <p className="episodeDate">{formattedDate}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    )
}